import { ReactNode } from "react";
import { Loader } from "react-feather";

import styles from "./payment-methods-busy.module.css";

type PaymentMethodsBusyProps = {
    busy: boolean;
    label: string;
    children: ReactNode;
    /** Mount children off-screen while busy (e.g. Stripe init) instead of overlaying them. */
    hideContentWhileBusy?: boolean;
    overlayClassName?: string;
    wrapClassName?: string;
};

export default function PaymentMethodsBusy({
    busy,
    label,
    children,
    hideContentWhileBusy = false,
    overlayClassName,
    wrapClassName,
}: PaymentMethodsBusyProps): JSX.Element {
    const hideVisibleContent = busy && hideContentWhileBusy;

    const content = hideContentWhileBusy ? (
        <div
            className={hideVisibleContent ? styles.offscreenInit : undefined}
            aria-hidden={hideVisibleContent ? true : undefined}
        >
            {children}
        </div>
    ) : (
        children
    );

    const wrapClasses = [
        styles.wrap,
        busy && hideContentWhileBusy ? styles.wrapLoading : "",
        wrapClassName ?? "",
    ]
        .filter(Boolean)
        .join(" ");

    const overlayClasses = [styles.overlay, overlayClassName ?? ""]
        .filter(Boolean)
        .join(" ");

    return (
        <div className={wrapClasses} aria-busy={busy}>
            {content}
            {busy &&
                (hideContentWhileBusy ? (
                    <div
                        className={styles.loadingShell}
                        role="status"
                        aria-live="polite"
                    >
                        <Loader className="spinorama" aria-hidden />
                        <span className={styles.label}>{label}</span>
                    </div>
                ) : (
                    <div
                        className={overlayClasses}
                        role="status"
                        aria-live="polite"
                    >
                        <Loader className="spinorama" aria-hidden />
                        <span className={styles.label}>{label}</span>
                    </div>
                ))}
        </div>
    );
}
